const Page = (number:any,setstartPage:any,setEndPage:any,setactive:any,pageDelimiter:any,setFetchData:any) => {
    setactive(number)
    setstartPage((number*pageDelimiter)-pageDelimiter)
    setEndPage(number*pageDelimiter)
    setFetchData(Date.now())
}

export default Page;
